import styled from "styled-components";

import { BenefitsListStyledProps as Props } from "./BenefitsList.types";
import CONSTANTS from "config/constants";

const { mobile } = CONSTANTS.BREAKPOINTS;

const BenefitsListStyled = styled.div<Props>`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 0.8rem;

  @media (max-width: ${mobile}px) {
    padding: 0;
  }

  .BenefitsList {
    &__buttonGroup {
      flex-direction: column;
      align-items: start;
    }

    &__button {
      border: none;
      width: 100%;
      flex: 1;

      &.Button--active {
        border: none;

        .CouponDetail__left__icon {
          border: 0.7rem solid var(--palette-primary);
        }
      }

      @media (max-width: ${mobile}px) {
        padding: 0;
      }
    }

    &__empty {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: center;
      align-items: center;

      &__title {
        font-size: 2.4rem;
        color: var(--palette-white);
        padding: 1.6rem 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 700;
      }

      &__message {
        font-size: 1.6rem;
        color: var(--palette-white);
        text-align: center;
      }
    }
  }
`;

export default BenefitsListStyled;
